import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,          // 20% of transactions for performance monitoring
  replaysSessionSampleRate: 0.1,  // 10% of all sessions
  replaysOnErrorSampleRate: 1.0,  // 100% of sessions where an error occurs
});
